import SmoothScroll from "./SmoothScroll";
import Navigation from "./Navigation";
import modalVideo from "./modalVideo";
import LightBox from "./LightBox";
import ContactFrom from "./ContactForm";
import CustomGa from './ga-custom-event';

(() => {
  const init = () => {
    Navigation();
    SmoothScroll(-80);
    modalVideo();
    LightBox();
    ContactFrom();
    CustomGa();
  };

  window.addEventListener("DOMContentLoaded", () => {
    init();
  });

  document.addEventListener("touchstart", (event) =>{}, { passive: true });
  document.addEventListener("wheel", (event) => {}, { passive: true });
})();
